// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ReactDom from "react-dom";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SLI$LiveRoom from "./client/bindings/SLI.bs.js";
import * as GoTo$LiveRoom from "./client/GoTo.bs.js";
import * as ReactI18next from "react-i18next";
import * as Apollo$LiveRoom from "./client/Apollo.bs.js";
import * as Config$LiveRoom from "./Config.bs.js";
import * as Loader$LiveRoom from "./client/Loader.bs.js";
import * as Router$LiveRoom from "./Router.bs.js";
import * as Datadog$LiveRoom from "./client/bindings/Datadog.bs.js";
import * as Segment$LiveRoom from "./client/bindings/Segment.bs.js";
import * as Utils_Web$LiveRoom from "./client/Utils/Utils_Web.bs.js";
import * as Notification$LiveRoom from "./client/components/Notification.bs.js";
import * as Translations$LiveRoom from "../translations/Translations.bs.js";
import * as AuthTokenHook$LiveRoom from "./client/stores/AuthTokenHook.bs.js";
import * as Utils_Auction$LiveRoom from "./client/Utils/Utils_Auction.bs.js";
import * as Utils_Logging$LiveRoom from "./client/Utils/Utils_Logging.bs.js";
import * as AuctionRoomPage$LiveRoom from "./client/pages/auctionRoom/AuctionRoomPage.bs.js";
import * as SecretContainer$LiveRoom from "./client/components/secret/SecretContainer.bs.js";
import * as ClientapiQueries$LiveRoom from "./client/ClientapiQueries.bs.js";
import * as FeatureFlagStore$LiveRoom from "./client/stores/FeatureFlagStore.bs.js";
import * as ConsentManagerDialog$LiveRoom from "./client/ConsentManagerDialog.bs.js";

require('./client/styles/reset.css')
;

require('./client/styles/global.css')
;

require('./client/styles/flexboxgrid.css')
;

require('swiper/css')
;

require('./client/bindings/Swiper.css')
;

function Index$LiveRoom(props) {
  var auctionSlug = props.auctionSlug;
  var auctionYear = props.auctionYear;
  var showSelectAccountModal = Utils_Web$LiveRoom.QueryString.isQueryParameterSet(Utils_Web$LiveRoom.QueryString.getQueryParameters(undefined), "showSelectAccountModal");
  var auctionQuery = Curry.app(ClientapiQueries$LiveRoom.Auction.AuctionBySlug.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        Curry._3(ClientapiQueries$LiveRoom.Auction.AuctionBySlug.makeVariables, {
              name: auctionSlug,
              year: auctionYear
            }, Translations$LiveRoom.getCatalogingLanguage(undefined), undefined)
      ]);
  React.useEffect((function () {
          var match = auctionQuery.error;
          if (match !== undefined) {
            var graphQLErrors = match.graphQLErrors;
            if (!Apollo$LiveRoom.checkForStatusCode(graphQLErrors, 401) && !Apollo$LiveRoom.checkForStatusCode(graphQLErrors, 403)) {
              Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                            hd: [
                              "error",
                              Belt_Option.mapWithDefault(Belt_Array.get(graphQLErrors, 0), "Unknown", Apollo$LiveRoom.getErrorMessage)
                            ],
                            tl: /* [] */0
                          })), undefined, undefined, "GraphQL error when loading live room");
            } else {
              Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                            hd: [
                              "error",
                              Belt_Option.getWithDefault(JSON.stringify(match.networkError), "")
                            ],
                            tl: /* [] */0
                          })), undefined, undefined, "Network error when loading live room");
            }
          }
          
        }), [auctionQuery.error]);
  var match = auctionQuery.data;
  var exit = 0;
  var match$1 = auctionQuery.error;
  if (auctionQuery.loading) {
    return React.createElement(Loader$LiveRoom.make, {});
  }
  if (match$1 !== undefined) {
    var graphQLErrors = match$1.graphQLErrors;
    if (Apollo$LiveRoom.checkForStatusCode(graphQLErrors, 401)) {
      return React.createElement(SecretContainer$LiveRoom.make, {
                  state: /* Login */0
                });
    }
    if (Apollo$LiveRoom.checkForStatusCode(graphQLErrors, 403)) {
      Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                    hd: [
                      "auctionName",
                      auctionSlug
                    ],
                    tl: {
                      hd: [
                        "auctionYear",
                        auctionYear
                      ],
                      tl: /* [] */0
                    }
                  })), undefined, undefined, "Unauthorized access attempt on auction");
      return React.createElement(SecretContainer$LiveRoom.make, {
                  state: /* NoAccess */1
                });
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && match !== undefined) {
    var auction = match.auctionBySlug;
    if (auction !== undefined && Caml_obj.equal(auction.state, "Live")) {
      SLI$LiveRoom.endTimer("Good", "LiveRoomLoad");
      return React.createElement(AuctionRoomPage$LiveRoom.make, {
                  auction: auction,
                  selectAccountInQuery: showSelectAccountModal
                });
    }
    
  }
  SLI$LiveRoom.endTimer("Bad", "LiveRoomLoad");
  GoTo$LiveRoom.auctionDetails(Utils_Auction$LiveRoom.getAuctionUrl(auctionSlug, auctionYear, undefined, undefined));
  return null;
}

var LiveRoom = {
  make: Index$LiveRoom
};

function Index$App(props) {
  var authToken = AuthTokenHook$LiveRoom.useToken("Index-LiveRoom");
  var match = Router$LiveRoom.getCurrentRoute(undefined);
  var tmp;
  if (match) {
    var auctionSlug = match._1;
    var auctionYear = match._0;
    if (typeof authToken === "object") {
      var variant = authToken.NAME;
      tmp = variant === "Authenticated" || variant === "AuthenticatedForPreview" ? React.createElement(Index$LiveRoom, {
              auctionYear: auctionYear,
              auctionSlug: auctionSlug
            }) : React.createElement(Loader$LiveRoom.make, {});
    } else {
      tmp = React.createElement(Index$LiveRoom, {
            auctionYear: auctionYear,
            auctionSlug: auctionSlug
          });
    }
  } else {
    tmp = "URL not valid";
  }
  return React.createElement(Datadog$LiveRoom.Provider.make, {
              children: React.createElement(Apollo$LiveRoom.Provider.make, {
                    children: React.createElement(FeatureFlagStore$LiveRoom.Provider.make, {
                          children: React.createElement(ReactI18next.I18nextProvider, {
                                i18n: Translations$LiveRoom.i18n,
                                children: null
                              }, Config$LiveRoom.tier === "Local" ? null : React.createElement(ConsentManagerDialog$LiveRoom.ConsentManager.make, {}), React.createElement(Notification$LiveRoom.make, {}), tmp)
                        })
                  })
            });
}

var App = {
  make: Index$App
};

Segment$LiveRoom.setupSegment(undefined);

Translations$LiveRoom.setupLanguage(undefined);

Belt_Option.forEach(Caml_option.nullable_to_opt(document.querySelector("#root")), (function (element) {
        ReactDom.render(React.createElement(Index$App, {}), element);
      }));

export {
  LiveRoom ,
  App ,
}
/*  Not a pure module */
